import React from 'react';
import './ServiceAbout.css';

const renderIcon = (type) => {
  switch (type) {
    case "blueprint":
      return (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
          <rect x="3" y="3" width="18" height="18" rx="2" ry="2" />
          <line x1="3" y1="9" x2="21" y2="9"></line>
          <line x1="9" y1="21" x2="9" y2="9"></line>
        </svg>
      );
    case "hospital":
      return (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M22 12h-4l-3 9L9 3l-3 9H2" />
        </svg>
      );
    case "staffing":
      return (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
          <circle cx="9" cy="7" r="4" />
          <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
          <path d="M16 3.13a4 4 0 0 1 0 7.75" />
        </svg>
      );
    case "readiness":
    case "audit":
    default:
      return (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
          <polyline points="14 2 14 8 20 8" />
          <line x1="16" y1="13" x2="8" y2="13" />
          <line x1="16" y1="17" x2="8" y2="17" />
        </svg>
      );
  }
};

const ServiceAbout = ({
  tagline,
  heading,
  paragraphs = [],
  pillars = []
}) => {
  if (!heading && (!paragraphs || paragraphs.length === 0)) return null;

  return (
    <section className="service-about-section">
      <div className="service-about-container">
        
        {/* --- 1. CENTERED TOP HEADER WITH LEFT & RIGHT DASHES --- */}
        <div className="service-about-header">
          {tagline && (
            <div className="service-about-eyebrow">
              <span className="service-about-eyebrow-dash"></span>
              <span>{tagline}</span>
              <span className="service-about-eyebrow-dash"></span>
            </div>
          )}

          {heading && (
            <h2 className="service-about-heading">
              {heading}
            </h2>
          )}

          {paragraphs && paragraphs.length > 0 && (
            <div className="service-about-paragraphs-wrapper">
              {paragraphs.map((p, index) => (
                <p key={index} className="service-about-description">
                  {p}
                </p>
              ))}
            </div>
          )}
        </div>

        {/* --- 2. 4 FEATURE PILLARS GRID --- */}
        {pillars && pillars.length > 0 && (
          <div className="service-about-pillars-grid">
            {pillars.map((item, index) => {
              const formattedNum = String(index + 1).padStart(2, '0');

              return (
                <div key={index} className="service-about-pillar-card">
                  
                  {/* Hover Accent Top Line */}
                  <div className="service-about-card-hover-bar"></div>

                  {/* Card Header Row */}
                  <div className="service-about-card-header">
                    <div className="service-about-icon-box">
                      {item.icon || renderIcon(item.iconType)}
                    </div>
                    
                    <div className="service-about-card-meta">
                      <span className="service-about-card-num">{formattedNum}</span>
                      {item.tag && (
                        <span className="service-about-tag-pill">{item.tag}</span>
                      )}
                    </div>
                  </div>

                  {/* Title & Desc */}
                  <h3 className="service-about-card-title">
                    {item.title}
                  </h3>

                  <p className="service-about-card-desc">
                    {item.description}
                  </p>
                </div>
              );
            })}
          </div>
        )}

      </div>
    </section>
  );
};

export default ServiceAbout;